import { useTranslation } from 'react-i18next'
import { MapPin, Clock, Phone, Mail } from 'lucide-react'
import { PageShell } from '../../components/layout/PageShell'
import { MapView } from '../../components/ui/MapView'
import { DirectionsButton } from '../../components/ui/DirectionsButton'

const MARKER = { lat: 45.4377, lon: 12.3172 }

export function ContactsPage() {
  const { t } = useTranslation()
  const phone = t('contacts.phoneVal')
  const phoneHref = `tel:${phone.replace(/[^\d+]/g, '')}`
  return (
    <PageShell>
      <div className="mb-6">
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-ink-900 sm:text-3xl">{t('contacts.title')}</h1>
        <p className="mt-1.5 text-sm text-ink-500">{t('contacts.subtitle')}</p>
      </div>

      <div className="rounded-2xl bg-white shadow-card ring-1 ring-ink-100">
        {/* the map clips its own top corners to match the card radius */}
        <div className="overflow-hidden rounded-t-2xl">
          <MapView lat={MARKER.lat} lon={MARKER.lon} className="aspect-[16/11] w-full sm:aspect-[2/1]" />
        </div>
        <div className="space-y-4 p-6">
          <Row icon={<MapPin className="h-4 w-4 text-brand-600" />} label={t('contacts.address')} value={t('home.address')} />
          <Row icon={<Clock className="h-4 w-4 text-brand-600" />} label={t('contacts.hours')} value={t('home.hours')} />
          <Row
            icon={<Phone className="h-4 w-4 text-brand-600" />}
            label={t('contacts.phone')}
            value={<a href={phoneHref} className="text-brand-600 hover:text-brand-800">{phone}</a>}
          />
          <Row
            icon={<Mail className="h-4 w-4 text-brand-600" />}
            label={t('contacts.email')}
            value={<a href={`mailto:${t('contacts.emailVal')}`} className="text-brand-600 hover:text-brand-800">{t('contacts.emailVal')}</a>}
          />
          <div className="pt-1">
            <DirectionsButton lat={MARKER.lat} lon={MARKER.lon} label={t('home.directions')} />
          </div>
        </div>
      </div>
    </PageShell>
  )
}

function Row({ icon, label, value }: { icon: React.ReactNode; label: string; value: React.ReactNode }) {
  return (
    <div className="flex items-start gap-3">
      <span className="mt-0.5 flex-none">{icon}</span>
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wide text-ink-400">{label}</p>
        <p className="text-sm font-semibold text-ink-900">{value}</p>
      </div>
    </div>
  )
}
